//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";

export interface NavSectionLabelProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  action?: ReactNode;
  rule?: boolean;
  collapsed?: boolean;
}

/** Kleine Überschrift, die Einträge der Seitenleiste gruppiert. */
export function NavSectionLabel({
  children,
  action,
  rule,
  collapsed,
  className = "",
  ...rest
}: NavSectionLabelProps) {
  if (collapsed) {
    return (
      <span
        className="bui-divider"
        data-orientation="horizontal"
        style={{ margin: "10px 8px" }}
      />
    );
  }
  return (
    <div className={`bui-nav-section ${className}`} {...rest}>
      {children}
      {rule && <span className="bui-nav-section__rule" />}
      {action && <span style={{ marginLeft: "auto" }}>{action}</span>}
    </div>
  );
}
